import _ from 'lodash'
import Api from 'redux-apis'

import { commonChildApiProps } from './commonUtils'

const normalizeServices = (enabled, disabled, running) => {
  const services = _
    .chain(enabled)
    .map(s => [s, {enabled: true, running: false}])
    .fromPairs()
    .value()

  const disabledServices = _
    .chain(disabled)
    .map(s => [s, {enabled: false, running: false}])
    .fromPairs()
    .value()

  const runningServices = _
    .chain(running)
    .map(s => [s, {running: true}])
    .fromPairs()
    .value()

  return _.merge(services, disabledServices, runningServices)
}


export default class Minions extends Api {
  constructor (saltApi) {
    //super({grains: {}, status: {}})
    super({})

    this.__cachedMinions = null
    Object.defineProperties(this, {
      ...commonChildApiProps(saltApi, this),
      minions: {
        enumerable: true, get: () => {
          if (this.__cachedMinions !== null) return this.__cachedMinions
          let state = this.getState()
          return this.__mergeGrainsAndStatus(
            state.grains || {},
            state.status || {})
          // this.__cachedMinions = this
          //   .__mergeGrainsAndStatus(state.grains, state.status)
          // return this.__cachedMinions
        }
      }
    })

    // Action handlers (reducers)
    this.setHandler('SET_GRAINS', (state, action) => {
      this.__cachedMinions = null
      return {...state, grains:_.merge(state.grains || {}, action.payload)}
    })
    this.setHandler('SET_STATUS', (state, action) => {
      this.__cachedMinions = null
      return {...state, status:_.merge(state.status || {}, action.payload)}
    })
  }

  __mergeGrainsAndStatus(grains, status, minionIds, onlyFromMinionIds) {
    let ids = minionIds || []
    if (!onlyFromMinionIds)
      ids = ids.concat(_.keys(grains||{}), _.keys(status||{}))
    return _
      .chain(ids)
      .uniq()
      .map(mid => {
        let data = _.extend(
          {id: mid}, grains[mid]||{},
          {status: ((status[mid] || false) ? 'up' : 'down')})
        return [mid, data]
      })
      .fromPairs()
      .value()
  }

  getGrains(mid) {
    return this
      .aio.get(`/minions/${ mid ? mid : ''}`)
      .then(res => res.data.return[0])
      .then(res => {
        if (!mid) {
          // who responded is up
          let statuses = _
            .chain(res)
            .map((grains, mid) => ([mid, _.isObject(grains)]))
            .fromPairs()
            .value()
          this.setStateChanges(['SET_GRAINS', 'SET_STATUS'], [res, statuses])
        } else if (res[mid] === undefined) {
          res[mid] = {}
          this.setStateChanges('SET_STATUS', {[mid]: false})
        }
        if (mid)
          return res[mid]
        return res
      })
  }

  getStatus(mid) {
    return this
      .aio.post('/', {
        client: 'local',
        expr_form: 'glob',
        tgt: mid ? mid : '*',
        fun: 'test.ping'
      })
      .then(res => res.data.return[0])
      .then(res => {
        if (mid && res[mid] === undefined)
          res[mid] = false
        // this.dispatch(this.createAction('SET_STATUS')(res))
        this.setStateChanges('SET_STATUS', res)
        if (mid)
          return res[mid]
        return res
      })
  }

  getServices(mid) {
    return Promise.all([
      this
        ._saltApi
        ._run(`${ mid ? mid : '*'}`, 'service.get_enabled'),
      this
        ._saltApi
        ._run(`${ mid ? mid : '*'}`, 'service.get_disabled'),
      this
        ._saltApi
        ._run(`${ mid ? mid : '*'}`, 'service.get_running'),
    ]).then(([enabled, disabled, running]) => {
      const mids = _
        .chain([_.keys(enabled), _.keys(disabled), _.keys(running)])
        .flatten()
        .uniq()
        .value()

      return _
        .chain(mids)
        .map(mid => [
          mid, normalizeServices(enabled[mid], disabled[mid], running[mid])
        ])
        .fromPairs()
        .value()
    })
  }
}



// WEBPACK FOOTER //
// ./src/saltapi/Minions.js